import { render, staticRenderFns } from "./reset-sealname.vue?vue&type=template&id=2a4e8cde&scoped=true&"
import script from "./reset-sealname.vue?vue&type=script&lang=js&"
export * from "./reset-sealname.vue?vue&type=script&lang=js&"
import style0 from "./reset-sealname.vue?vue&type=style&index=0&id=2a4e8cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e8cde",
  null
  
)

export default component.exports